import React from 'react';
import { useUIStore } from '@/stores/uiStore';
import './ToastContainer.css';

/**
 * トーストタイプに対応するインラインSVGアイコン
 * stroke/fill="currentColor" で親の CSS color を継承し、
 * type 別ネオン色は ToastContainer.css の .Toast--{type} .Toast__icon { color } で制御する
 */
const TOAST_ICONS: Record<string, React.ReactNode> = {
  info: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="8" x2="12" y2="8.5" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="12" y1="12" x2="12" y2="16" />
    </svg>
  ),
  success: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12l3 3 5-6" />
    </svg>
  ),
  warning: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12" y2="17.5" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  ),
  error: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),
};

/**
 * ToastContainer - トースト通知を表示するコンテナ
 * uiStoreのtoastsを購読して、各トーストを表示する
 */
export const ToastContainer: React.FC = () => {
  const toasts = useUIStore((state) => state.toasts);
  const dismissToast = useUIStore((state) => state.dismissToast);

  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className="ToastContainer" role="region" aria-label="通知">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`Toast Toast--${toast.type}`}
          role="alert"
          aria-live="polite"
        >
          <span className="Toast__icon" aria-hidden="true">
            {TOAST_ICONS[toast.type]}
          </span>
          <span className="Toast__content">{toast.message}</span>
          <button
            className="Toast__close"
            onClick={() => dismissToast(toast.id)}
            aria-label="閉じる"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
